export default {
  en: {
    closed: 'implement closed label',
    total: {
      zero: 'implement zero count label %{count}',
      one: 'implement one count label %{count}',
      other: 'implement many count label %{count}',
    },
  },
};
